import { Button, Card, Col, Collapse, Container, Form, InputGroup, ListGroup, Row } from "react-bootstrap";
import { CiSquarePlus } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import SocialIconList from "./SocialIconList";
import UseToggle from "../../../Hooks/UseToggle";
import { useState } from "react";
import { FiCopy, FiEye } from "react-icons/fi";
import config from "../../../config/config.json";
import PagePreview from "./PagePreview";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import CustomSection from "./Sections/CustomSection";
import { FaRegEdit } from "react-icons/fa";
import ExpertiseSection from "./Sections/ExpertiseSection";
import ServicesSection from "./Sections/ServicesSection";
import ServicesDetails from "../../LandingPage/Sections/ServicesDetails";
import { TbReload } from "react-icons/tb";
import FileManagementModal from "./FileManagementModal";

function PageSetup({
  addUpdatePage,
  saveLoader,

  pageLogo,
  setPageLogo,
  themeColor,
  setThemeColor,
  pageName,
  setPageName,
  pageIdentifier,
  setPageIdentifier,
  tabsManage,
  setTabsManage,
  blogMenu,
  setBlogMenu,
  storeMenu,
  setStoreMenu,

  heroBadgeTitle,
  setHeroBadgeTitle,
  heroHeading,
  setHeroHeading,
  heroDescription,
  setHeroDescription,
  heroHighLightedKey,
  setHeroHighLightedKey,
  viewServicesButton,
  setViewServicesButton,

  aboutSection,
  setAboutSection,
  aboutTitle,
  setAboutTitle,
  about,
  setAbout,

  customDataSection,
  setCustomDataSection,
  customDataSectionTitle,
  setCustomDataSectionTitle,
  customDataSectionSubTitle,
  setCustomDataSectionSubTitle,
  customData,
  setCustomData,

  expertiseSection,
  setExpertiseSection,
  expertiseSectionTitle,
  setExpertiseSectionTitle,
  expertiseSectionSubTitle,
  setExpertiseSectionSubTitle,
  expertise,
  setExpertise,

  servicesSection,
  setServicesSection,
  servicesSectionTitle,
  setServicesSectionTitle,
  servicesSectionSubTitle,
  setServicesSectionSubTitle,
  services,
  setServices,

  footerSection,
  setFooterSection,
  widgetFloatingIcon,
  setWidgetFloatingIcon,
  footerAdditionalText,
  setFooterAdditionalText,
  socialLinks,

  addSocialRow,
  removeSocialRow,
  handleSocialChange,
  hasEmptySocialLinks,
  ICON_MAP,
  handleInputChange,
}) {
  const [index, setIndex] = useState(null);
  const [sectionData, setSectionData] = useState("");
  const [mode, setMode] = useState("");
  const toggles = UseToggle();

  const moveUp = (index) => {
    if (index === 0) return;

    const updated = [...tabsManage];
    [updated[index - 1], updated[index]] = [
      updated[index],
      updated[index - 1],
    ];

    setTabsManage(updated);
  };

  const moveDown = (index) => {
    if (index === tabsManage?.length - 1) return;

    const updated = [...tabsManage];
    [updated[index + 1], updated[index]] = [
      updated[index],
      updated[index + 1],
    ];

    setTabsManage(updated);
  };

  const hideShowMenu = (id) => {
    setTabsManage(prev =>
      prev.map(item =>
        item.id === id
          ? { ...item, isShow: !item.isShow }
          : item
      )
    );
  };

  const handleTabNameChange = (id, value) => {
    setTabsManage(prev =>
      prev.map(tab =>
        tab.id === id
          ? { ...tab, name: value || id }
          : tab
      )
    );
  };

  const addHeroHighLightedKeyRow = () => {
    setHeroHighLightedKey([...heroHighLightedKey, { title: "" }]);
  };

  const removeHeroHighLightedKeyRow = (index) => {
    const updated = [...heroHighLightedKey];
    updated.splice(index, 1);
    setHeroHighLightedKey(updated);
  };

  const handleHeroHighLightedKeyChange = (index, field, value) => {
    const updated = [...heroHighLightedKey];
    updated[index][field] = value;
    setHeroHighLightedKey(updated);
  };

  const hasEmptyHeroHighLightedKey = () => {
    if (
      heroHighLightedKey?.length === 1 &&
      !heroHighLightedKey[0]?.title
    ) {
      return false;
    }
    return heroHighLightedKey?.some(
      (item) =>
        !item.title?.trim()
    );
  };

  const handleCustomSectionClick = (mode, index) => {
    setMode(mode);
    setIndex(index);
    toggles.setToggle2();
    if (mode === "edit") {
      setSectionData(customData?.[index])
    } else {
      setSectionData({
        title: "",
        subtitle: "",
        startDate: "",
        endDate: "",
        description: "",
      })
    }
  };

  const handleCustomSectionDelete = (index) => {
    setCustomData(prev => prev.filter((_, i) => i !== index));
  };

  const handleExpertiseSectionClick = (mode, index) => {
    setMode(mode);
    setIndex(index);
    toggles.setToggle3();
    if (mode === "edit") {
      setSectionData(expertise?.[index])
    } else {
      setSectionData({
        title: "",
        description: "",
        points: [],
        highlights: [],
      })
    }
  };

  const handleExpertiseSectionDelete = (index) => {
    setExpertise(prev => prev.filter((_, i) => i !== index));
  };

  const handleServicesSectionClick = (mode, index) => {
    setMode(mode);
    setIndex(index);
    toggles.setToggle4();
    if (mode === "edit") {
      setSectionData(services?.[index])
    } else {
      setSectionData({
        title: "",
        shortDescription: "",
        longDescription: "",
      })
    }
  };

  const colors = [
    "#FF5733", "#33FF57", "#3357FF", "#FF33A8", "#A833FF",
    "#33FFF3", "#FFC733", "#FF8F33", "#33FF8F", "#8FFF33",
    "#FF3333", "#33FF33", "#3333FF", "#FF33FF", "#33FFFF",
    "#999999", "#000000", "#F1C40F", "#2ECC71"
  ];

  const handleServicesSectionDelete = (index) => {
    setServices(prev => prev.filter((_, i) => i !== index));
  };
  return (
    <>
      <div className="h-100 d-flex flex-column w-100">
        <div className="bg-white border-bottom px-4 py-3">
          <div className="hstack justify-content-between">
            <div>
              <h6 className="fw-semibold m-0">Page Settings</h6>
              <Form.Text className="text-muted" style={{ fontSize: 13 }}>
                Update and control landing page
              </Form.Text>
            </div>
            <div className="hstack gap-2">
              <Button variant="outline-primary" size="sm" onClick={toggles.setToggle1}>
                Page Preview
              </Button>
              <Button
                onClick={addUpdatePage}
                disabled={hasEmptySocialLinks() || hasEmptyHeroHighLightedKey() || saveLoader}
                variant="primary" size="sm">
                Save Changes
              </Button>
            </div>
          </div>
        </div>

        <div
          className="flex-grow-1 overflow-auto p-4"
          style={{ height: "calc(100vh - 132px)" }}
        >
          <Row className="g-4">
            <Col xxl={7}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold mb-3">Hero Section</h6>
                  <Row className="g-3">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Badge Title</Form.Label>
                        <Form.Control
                          onChange={handleInputChange(setHeroBadgeTitle)}
                          value={heroBadgeTitle}
                          placeholder="Enter Badge Title"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Heading</Form.Label>
                        <Form.Control
                          onChange={handleInputChange(setHeroHeading)}
                          value={heroHeading}
                          placeholder="Enter hero Heading" />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as={`textarea`}
                          onChange={handleInputChange(setHeroDescription)}
                          value={heroDescription}
                          placeholder="Enter hero Description"
                        />
                      </Form.Group>
                    </Col>
                    {servicesSection &&
                      <Col md={12}>
                        <div className="hstack gap-3 mb-0">
                          <Form.Label>Service Button</Form.Label>
                          <Form.Check
                            type="switch"
                            onChange={() => setViewServicesButton(!viewServicesButton)}
                            checked={viewServicesButton}
                          />
                        </div>
                      </Col>
                    }
                    <Col md={12}>
                      <Form.Group>
                        <div className="hstack gap-2">
                          <Form.Label>Highlighted Key</Form.Label>
                          <CiSquarePlus
                            title="Add More"
                            className="mb-1 text-success CP"
                            onClick={addHeroHighLightedKeyRow}
                          />
                        </div>
                        {heroHighLightedKey?.map((item, index) => {
                          return (
                            <InputGroup key={index} className="mb-2">
                              <Form.Control
                                placeholder="Enter Title"
                                value={item.title}
                                onChange={(e) =>
                                  handleHeroHighLightedKeyChange(
                                    index,
                                    "title",
                                    e.target.value,
                                  )
                                }
                              />
                              <InputGroup.Text>
                                <GoTrash
                                  style={{ fontSize: 15 }}
                                  className="text-danger CP"
                                  title="Delete"
                                  onClick={() =>
                                    removeHeroHighLightedKeyRow(index)
                                  }
                                />
                              </InputGroup.Text>
                            </InputGroup>
                          );
                        })}
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-3">
                    <h6 className="fw-semibold mb-0">About Section</h6>
                    <Form.Check
                      type="switch"
                      onChange={() => { hideShowMenu("about"); setAboutSection(!aboutSection) }}
                      checked={aboutSection}
                    />
                  </div>
                  <Collapse in={aboutSection}>
                    <div>
                      <Form.Group className="mb-2">
                        <Form.Label>Heading</Form.Label>
                        <Form.Control
                          onChange={(e) => { handleTabNameChange("about", e.target.value); setAboutTitle(e.target.value) }}
                          value={aboutTitle}
                          placeholder="Enter Heading" />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Long Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          onChange={handleInputChange(setAbout)}
                          value={about}
                          placeholder="Enter Description"
                        />
                      </Form.Group>
                    </div>
                  </Collapse>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className=" hstack justify-content-between mb-3">
                    <div>
                      <h6 className="fw-semibold m-0">Custom Section</h6>
                      <small className="text-muted">
                        Add and manage experiences, timeline, education, milestones, achievements, journey or anythings
                      </small>
                    </div>
                    <Form.Check
                      onChange={() => { hideShowMenu("custom"); setCustomDataSection(!customDataSection) }}
                      checked={customDataSection}
                      type="switch" />
                  </div>
                  <Collapse in={customDataSection}>
                    <div>
                      <Card className="border mb-3">
                        <Card.Body>
                          <Form.Group className="mb-2">
                            <Form.Label>Heading</Form.Label>
                            <Form.Control
                              onChange={(e) => { handleTabNameChange("custom", e.target.value); setCustomDataSectionTitle(e.target.value) }}
                              value={customDataSectionTitle}
                              placeholder="Enter Heading" />
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Label>Sub Heading</Form.Label>
                            <Form.Control
                              onChange={handleInputChange(setCustomDataSectionSubTitle)}
                              value={customDataSectionSubTitle}
                              placeholder="Enter Sub Heading" />
                          </Form.Group>
                        </Card.Body>
                      </Card>
                      <div className="hstack gap-2 mb-2">
                        <Form.Label className="text-muted m-0">
                          Add More
                        </Form.Label>
                        <CiSquarePlus
                          title="Add More"
                          onClick={() => handleCustomSectionClick("add", null)}
                          className="text-success CP"
                        />
                      </div>
                      <div className="position-relative">
                        <div
                          style={{
                            position: "absolute",
                            left: "7px",
                            top: 0,
                            bottom: 0,
                            width: "2px",
                            background: "#dee2e6",
                          }}
                        />
                        {customData?.map((item, index) => (
                          <div className="d-flex mb-5">
                            <div
                              style={{
                                width: 16,
                                height: 16,
                                borderRadius: "50%",
                                background: "#0d6efd",
                                position: "absolute",
                              }}
                            />
                            <div style={{ marginTop: -4 }} className="ms-4 w-100">
                              <div className="hstack justify-content-between mb-1">
                                <Form.Label style={{ fontSize: 15 }} className="fw-bold ">
                                  {item?.title}
                                </Form.Label>
                                <div className="hstack gap-3">
                                  <FaRegEdit
                                    className="text-primary CP"
                                    onClick={() => handleCustomSectionClick("edit", index)}
                                  />
                                  <GoTrash
                                    className="text-danger CP"
                                    onClick={() => handleCustomSectionDelete(index)}
                                  />
                                </div>
                              </div>
                              <div style={{ fontSize: 14 }} className="text-muted small">
                                {item?.subtitle} • {item?.startDate} – {item?.endDate}
                              </div>
                              <p style={{ fontSize: 14 }} className="text-muted mt-2 mb-0">{item?.description}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Collapse>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-3">
                    <div>
                      <h6 className="fw-semibold mb-1">Expertise</h6>
                      <small className="text-muted">
                        Technologies and expertise
                      </small>
                    </div>
                    <Form.Check
                      onChange={() => { hideShowMenu("expertise"); setExpertiseSection(!expertiseSection) }}
                      checked={expertiseSection}
                      type="switch" />
                  </div>
                  <Collapse in={expertiseSection}>
                    <div>
                      <Card className="border mb-3">
                        <Card.Body>
                          <Form.Group className="mb-2">
                            <Form.Label>Heading</Form.Label>
                            <Form.Control
                              onChange={(e) => { handleTabNameChange("expertise", e.target.value); setExpertiseSectionTitle(e.target.value) }}
                              value={expertiseSectionTitle}
                              placeholder="Enter Heading" />
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Label>Sub Heading</Form.Label>
                            <Form.Control
                              onChange={handleInputChange(setExpertiseSectionSubTitle)}
                              value={expertiseSectionSubTitle}
                              placeholder="Enter Sub Heading" />
                          </Form.Group>
                        </Card.Body>
                      </Card>
                      <div className="hstack gap-2 mb-2">
                        <Form.Label className="text-muted m-0">
                          Add Expertise
                        </Form.Label>
                        <CiSquarePlus
                          title="Add More"
                          onClick={() => handleExpertiseSectionClick("add", null)}
                          className="text-success CP"
                        />
                      </div>
                      {expertise?.map((item, index) => (
                        <Card key={index} className="border mb-3">
                          <Card.Body>
                            <div className="hstack justify-content-between mb-1">
                              <Form.Label style={{ fontSize: 15 }} className="fw-bold ">
                                {item?.title}
                              </Form.Label>
                              <div className="hstack gap-3">
                                <FaRegEdit
                                  className="text-primary CP"
                                  onClick={() => handleExpertiseSectionClick("edit", index)}
                                />
                                <GoTrash
                                  className="text-danger CP"
                                  onClick={() => handleExpertiseSectionDelete(index)}
                                />
                              </div>
                            </div>
                            <p style={{ fontSize: 14 }} className="text-muted">
                              {item?.description}
                            </p>
                            {(item?.points || [])?.length > 0 &&
                              <ul style={{ fontSize: 14 }} className="text-muted">
                                {(item?.points || [])?.map(point => (
                                  <li>
                                    {point}
                                  </li>
                                ))}
                              </ul>
                            }
                            {(item?.highlights || [])?.length > 0 &&
                              <div style={{ fontSize: 13 }} className="mt-3">
                                {(item?.highlights || []).map((highlight) => (
                                  <span className="badge bg-primary me-2 mb-2">
                                    {highlight}
                                  </span>
                                ))}
                              </div>
                            }
                          </Card.Body>
                        </Card>
                      ))}
                    </div>
                  </Collapse>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-3">
                    <div>
                      <h6 className="fw-semibold m-0">Services</h6>
                      <small className="text-muted">
                        Manage services you offer
                      </small>
                    </div>
                    <Form.Check
                      onChange={() => { hideShowMenu("services"); setServicesSection(!servicesSection) }}
                      checked={servicesSection}
                      type="switch" />
                  </div>
                  <Collapse in={servicesSection}>
                    <div>
                      <Card className="border mb-3">
                        <Card.Body>
                          <Form.Group className="mb-2">
                            <Form.Label>Heading</Form.Label>
                            <Form.Control
                              onChange={(e) => { handleTabNameChange("services", e.target.value); setServicesSectionTitle(e.target.value) }}
                              value={servicesSectionTitle}
                              placeholder="Enter Heading" />
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Label>Sub Heading</Form.Label>
                            <Form.Control
                              onChange={handleInputChange(setServicesSectionSubTitle)}
                              value={servicesSectionSubTitle}
                              placeholder="Enter Sub Heading" />
                          </Form.Group>
                        </Card.Body>
                      </Card>
                      <div className="hstack gap-2 mb-2">
                        <Form.Label className="text-muted m-0">
                          Add Services
                        </Form.Label>
                        <CiSquarePlus
                          title="Add More"
                          onClick={() => handleServicesSectionClick("add", null)}
                          className="text-success CP"
                        />
                      </div>
                      <Row>
                        {services?.map((item, index) => (
                          <Col md={6}>
                            <Card key={item} className="border mb-3">
                              <Card.Img
                                variant="top"
                                style={{ height: 200, objectFit: "cover" }}
                                src={"https://i.pravatar.cc/?img=1"}
                              />
                              <Card.Body>
                                <Form.Label style={{ fontSize: 15 }} className="fw-bold ">
                                  {item?.title}
                                </Form.Label>
                                <p style={{ fontSize: 14 }} className="text-muted">{item?.shortDescription}</p>
                                <div className="hstack justify-content-between mb-1">
                                  <Button
                                    variant="outline-primary"
                                    className="fw-semibold px-3"
                                    size="sm"
                                    style={{ fontSize: 12 }}
                                    onClick={() => { setSectionData(item); toggles.setToggle5() }}
                                  >
                                    View Details
                                  </Button>
                                  <div className="hstack gap-3">
                                    <FaRegEdit
                                      className="text-primary CP"
                                      onClick={() => handleServicesSectionClick("edit", index)}
                                    />
                                    <GoTrash
                                      className="text-danger CP"
                                      onClick={() => handleServicesSectionDelete(index)}
                                    />
                                  </div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Collapse>
                </Card.Body>
              </Card>
            </Col>
            <Col xxl={5}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold mb-3">Page Identifier</h6>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Page URL (
                      <Form.Text className="text-muted" style={{ fontSize: 10 }}>
                        This is the unique page URL from
                      </Form.Text>
                      )
                    </Form.Label>
                    <InputGroup>
                      <InputGroup.Text style={{ fontSize: 12 }}>
                        {config.baseURL}/
                      </InputGroup.Text>
                      <Form.Control
                        onChange={handleInputChange(setPageIdentifier)}
                        value={pageIdentifier}
                        placeholder="Enter page identifier"
                      />
                      <InputGroup.Text className="CP" title="Copy URL"><FiCopy /></InputGroup.Text>
                      <InputGroup.Text className="CP" title="View Page"><FiEye /></InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <div className="hstack justify-content-between mb-3">
                    <h6 className="fw-semibold m-0">Theme Color</h6>
                    <Button variant="outline-danger" size="sm" className="px-2 hstack gap-1" style={{ fontSize: 11 }} onClick={() => setThemeColor("#007bff")}><TbReload style={{ marginTop: 2 }} /> Reset</Button>
                  </div>
                  <Form.Group className="mb-2">
                    <Form.Label className="mb-1">
                      Choose Theme Color
                    </Form.Label>
                    <Form.Group className="hstack flex-wrap gap-1">
                      {colors.map((color, index) => (
                        <div
                          key={index}
                          onClick={() => setThemeColor(color)}
                          style={{
                            width: 25,
                            height: 25,
                            backgroundColor: color,
                            borderRadius: 4,
                            cursor: "pointer",
                            border: themeColor === color ? "2px solid #000" : "1px solid #ccc"
                          }}
                          title={color}
                        />
                      ))}
                    </Form.Group>
                  </Form.Group>
                </Card.Body>
              </Card>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Body>
                  <h6 className="fw-semibold mb-3">Header</h6>
                  <Card className="border mb-3">
                    <Card.Body>
                      <Form.Label>Brand Image</Form.Label>
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded border bg-light d-flex align-items-center justify-content-center"
                          style={{ width: 96, height: 96 }}
                        >
                          <img
                            src={
                              "https://tawk.link/5edc81e54a7c6258179a1405/var/logo/u30481uPlW.png?width=40&height=40"
                            }
                            alt="logo"
                            className="brand-logo"
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        <div>
                          <small className="text-muted d-block mb-2">
                            PNG or JPG · 512×512
                          </small>
                          <Button size="sm" variant="outline-primary" onClick={toggles.setToggle6}>
                            Upload Image
                          </Button>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                  <Card className="border mb-3">
                    <Card.Body>
                      <Form.Group>
                        <Form.Label>Brand Name</Form.Label>
                        <Form.Control
                          onChange={handleInputChange(setPageName)}
                          value={pageName}
                          placeholder="Brand Name" />
                      </Form.Group>
                    </Card.Body>
                  </Card>
                  <Card className="border mb-3">
                    <Card.Body>
                      <Form.Group>
                        <div className="d-flex justify-content-between mb-3">
                          <div>
                            <Form.Label>Menu Section</Form.Label>
                            <Form.Label style={{fontSize: 10}}>Manage and Arrange Menu </Form.Label>
                          </div>
                          <div>
                            <Form.Check
                              type="switch"
                              style={{ fontSize: 12 }}
                              className="text-muted"
                              onChange={() => { hideShowMenu("blog"); setBlogMenu(!blogMenu) }}
                              checked={blogMenu}
                              label="Enable/Disable Blog"
                            />
                            <Form.Check
                              type="switch"
                              style={{ fontSize: 12 }}
                              className="text-muted"
                              onChange={() => { hideShowMenu("store"); setStoreMenu(!storeMenu) }}
                              checked={storeMenu}
                              label="Enable/Disable Store"
                            />
                          </div>
                        </div>
                        <ListGroup style={{ fontSize: 12 }}>
                          {tabsManage?.map((item, index) => (
                            <ListGroup.Item
                              key={item.id}
                              className="hstack justify-content-between"
                              action
                            >
                              <span className={`text-capitalize ${item?.isShow ? "text-success" : "text-danger"}`}>{item.name || item?.id}</span>
                              <span className="hstack gap-2">
                                <FaAngleUp
                                  style={{
                                    cursor: index === 0 ? "not-allowed" : "pointer",
                                    opacity: index === 0 ? 0.3 : 1,
                                  }}
                                  onClick={() => moveUp(index)}
                                />
                                <FaAngleDown
                                  style={{
                                    cursor:
                                      index === tabsManage?.length - 1
                                        ? "not-allowed"
                                        : "pointer",
                                    opacity:
                                      index === tabsManage?.length - 1 ? 0.3 : 1,
                                  }}
                                  onClick={() => moveDown(index)}
                                />
                              </span>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      </Form.Group>
                    </Card.Body>
                  </Card>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm">
                <Card.Body>
                  <div className="hstack justify-content-between mb-3">
                    <h6 className="fw-semibold mb-1">Footer</h6>
                    <Form.Check
                      onChange={handleInputChange(setFooterSection)}
                      checked={footerSection}
                      type="switch" />
                  </div>
                  <Collapse in={footerSection}>
                    <div>
                      <Card className="border mb-3">
                        <Card.Body>
                          <h6 className="mb-2">Copyright section</h6>
                          <Form.Group>
                            <Form.Label
                              className="text-muted mb-1">
                              Footer copyright text
                            </Form.Label>
                            <InputGroup className="mb-2">
                              <Form.Control
                                style={{ width: "40%" }}
                                placeholder={`© ${new Date().getFullYear()} Brand Name`}
                                readOnly
                              />
                              <Form.Control
                                style={{ width: "60%" }}
                                placeholder="Addtional Text"
                                onChange={handleInputChange(setFooterAdditionalText)}
                                value={footerAdditionalText}
                              />
                            </InputGroup>
                          </Form.Group>
                        </Card.Body>
                      </Card>
                      <Card className="border mb-3">
                        <Card.Body>
                          <h6 className="mb-2">Social Links</h6>
                          <Form.Group>
                            <div className="hstack gap-2 mb-2">
                              <Form.Label className="text-muted m-0">
                                Social Media Links
                              </Form.Label>
                              <CiSquarePlus
                                title="Add More"
                                className="text-success CP"
                                onClick={addSocialRow}
                              />
                            </div>
                            {socialLinks?.map((item, index) => {
                              const IconComponent = ICON_MAP[item.icon];
                              return (
                                <InputGroup key={index} className="mb-2">
                                  <Button
                                    title={item?.icon}
                                    style={{
                                      width: item.icon ? "10%" : "20%",
                                      fontSize: 12,
                                    }}
                                    className="text-nowrap"
                                    onClick={() => {
                                      toggles.setToggle();
                                      setIndex(index);
                                    }}
                                  >
                                    {IconComponent ? (
                                      <IconComponent size={16} />
                                    ) : (
                                      "Select Icon"
                                    )}
                                  </Button>
                                  <Form.Control
                                    style={{ width: item.icon ? "20%" : "20%" }}
                                    placeholder="Enter Title"
                                    value={item.title}
                                    onChange={(e) =>
                                      handleSocialChange(
                                        index,
                                        "title",
                                        e.target.value,
                                      )
                                    }
                                  />
                                  <Form.Control
                                    style={{ width: item.icon ? "55%" : "50%" }}
                                    placeholder="Enter URL"
                                    value={item.url}
                                    onChange={(e) =>
                                      handleSocialChange(
                                        index,
                                        "url",
                                        e.target.value,
                                      )
                                    }
                                  />
                                  <InputGroup.Text>
                                    <GoTrash
                                      style={{ fontSize: 15 }}
                                      className="text-danger CP"
                                      title="Delete"
                                      onClick={() => removeSocialRow(index)}
                                    />
                                  </InputGroup.Text>
                                </InputGroup>
                              );
                            })}
                          </Form.Group>
                        </Card.Body>
                      </Card>
                    </div>
                  </Collapse>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <SocialIconList
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Select Social Icons`}
        onSelect={(icon, color) => {
          handleSocialChange(index, "icon", icon);
          handleSocialChange(index, "color", color);
          handleSocialChange(index, "title", icon);
        }}
      />
      <PagePreview
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Page Preview`}
        pageId={pageIdentifier}
      />
      <CustomSection
        show={!toggles.toggle2}
        hide={() => toggles.setToggle2()}
        index={index}
        mode={mode}
        setMode={setMode}
        setIndex={setIndex}
        sectionData={sectionData}
        setSectionData={setSectionData}
        setCustomData={setCustomData}
      />
      <ExpertiseSection
        show={!toggles.toggle3}
        hide={() => toggles.setToggle3()}
        index={index}
        mode={mode}
        setMode={setMode}
        setIndex={setIndex}
        sectionData={sectionData}
        setSectionData={setSectionData}
        setExpertise={setExpertise}
      />
      <ServicesSection
        show={!toggles.toggle4}
        hide={() => toggles.setToggle4()}
        index={index}
        mode={mode}
        setMode={setMode}
        setIndex={setIndex}
        sectionData={sectionData}
        setSectionData={setSectionData}
        setServices={setServices}
      />
      <ServicesDetails
        show={!toggles.toggle5}
        hide={() => toggles.setToggle5()}
        selectedService={sectionData}
      />
      <FileManagementModal
        show={!toggles.toggle6}
        hide={toggles.setToggle6}
      />
    </>
  );
}

export default PageSetup;
